import React from "react";

const currencyFmt = new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

const numberFmt = new Intl.NumberFormat("es-AR");

const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("es-AR");
};

const TablaExcepcionAnticipo = ({ data, loading, error, onDescargarDia, descargandoDia }) => {
    if (loading) return <div className="tabla-loading">Cargando...</div>;
    if (error) return <div className="tabla-error">{error}</div>;
    if (!data || data.length === 0) return <div className="tabla-vacia">Sin datos</div>;

    const totals = data.reduce(
        (acc, row) => {
            acc.totalBruto += row.TotalBruto ?? row.totalBruto ?? 0;
            acc.cantOp += row.CantidadOperaciones ?? row.cantidadOperaciones ?? 0;
            acc.cantPag += row.CantidadPagadas ?? row.cantidadPagadas ?? 0;
            acc.cantPen += row.CantidadPendientes ?? row.cantidadPendientes ?? 0;
            return acc;
        },
        { totalBruto: 0, cantOp: 0, cantPag: 0, cantPen: 0 }
    );

    return (
        <div className="bg-tabla-calculadora">
            <table className="table table-borderless table-hover">
                <thead className="bg-dark py-2">
                    <tr className="text-center tabla-thead text-white">
                        <th className="fs-12 lato-regular py-2 border-tabla-izquierda">Fecha</th>
                        <th className="fs-12 lato-regular py-2">Total Bruto</th>
                        <th className="fs-12 lato-regular py-2">Operaciones</th>
                        <th className="fs-12 lato-regular py-2">Pagadas</th>
                        <th className="fs-12 lato-regular py-2">Pendientes</th>
                        <th className="fs-12 lato-regular py-2 border-tabla-derecha">Excel Día</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, idx) => {
                        const fecha = row.Fecha ?? row.fecha;
                        const totalBruto = row.TotalBruto ?? row.totalBruto ?? 0;
                        const cantOp = row.CantidadOperaciones ?? row.cantidadOperaciones ?? 0;
                        const cantPag = row.CantidadPagadas ?? row.cantidadPagadas ?? 0;
                        const cantPen = row.CantidadPendientes ?? row.cantidadPendientes ?? 0;

                        return (
                            <tr key={`${fecha || "row"}-${idx}`} className="text-center">
                                <td className="fs-12 lato-regular py-2">{formatDate(fecha)}</td>
                                <td className="fs-12 lato-regular py-2">{currencyFmt.format(totalBruto)}</td>
                                <td className="fs-12 lato-regular py-2">{numberFmt.format(cantOp)}</td>
                                <td className="fs-12 lato-regular py-2">{numberFmt.format(cantPag)}</td>
                                <td className="fs-12 lato-regular py-2">{numberFmt.format(cantPen)}</td>
                                <td className="fs-12 lato-regular py-2">
                                    <button
                                        className="btn btn-dark"
                                        onClick={() => onDescargarDia(fecha)}
                                        disabled={descargandoDia}
                                    >
                                        {descargandoDia ? "..." : "Descargar"}
                                    </button>
                                </td>
                            </tr>
                        );
                    })}

                    <tr className="text-center">
                        <td className="fs-12 lato-bold py-2">Total</td>
                        <td className="fs-12 lato-bold py-2">{currencyFmt.format(totals.totalBruto)}</td>
                        <td className="fs-12 lato-bold py-2">{numberFmt.format(totals.cantOp)}</td>
                        <td className="fs-12 lato-bold py-2">{numberFmt.format(totals.cantPag)}</td>
                        <td className="fs-12 lato-bold py-2">{numberFmt.format(totals.cantPen)}</td>
                        <td className="fs-12 lato-bold py-2">-</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default TablaExcepcionAnticipo;
